<template>
  <div class="setup-account" style="height: 100%;">
    <!-- <div class="top-header">
      <div>
        <img src="@/assets/logo-fff-small.png" />
        <div>
          <span class="welcome">
            Welcome
            <strong>{{ name }}</strong>
          </span>
          &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;
          <span class="logout" @click="logout">
            <i class="fa fa-sign-out-alt"></i> Logout
          </span>
          &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;
          <span class="help">
            Help
            <i class="fa fa-question"></i>
          </span>
        </div>
      </div>
    </div> -->
    <div class="security-question">
      <div class="setup">
        <p class="mb-5"><img src="../../public/logo-small.png" /></p>
        <h3>Authenticate</h3>
        <p>Enter answer to your security question to continue</p>
        <div class="form" @keyup="authuser">
          <div class="error-login animated slideInUp" v-if="error.message">
            Anwser is incorrect
            <i class="fa fa-times" @click="close"></i>
          </div>
          <div>
            <!--<label>Security Question Answer</label>-->
            <input
              type="password"
              v-model="answer"
              placeholder="***************"
              @keypress="hideError"
            />
            <span class="error" v-if="error.answer">Please enter your security question answer</span>
          </div>
          <div class="submit">
            <button type="button" @click="submit">Continue</button>
            <span @click="forgot_question" style="color:#3F96D1; font-weight:bold; font-size: 14px;">Reset security question</span>
          </div>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
    <sendquestion ref="sendquestion"></sendquestion>
    <logout ref="logout"></logout>
  </div>
</template>
<style scoped>
.security-question {
  height: calc(100% - 40px);
}
  .security-question .setup-name {
    background: transparent !important;
  }
  .user-adding ul {
    margin-bottom: 2.5em;
    margin-top: 1em;
  }
  .user-adding .avatar2 {
    display: inline-flex;
    width: 48px !important;
    height: 48px !important;
    background-color: #E8F0F6 !important;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .user-adding .dept {
    font-family: 'DM Sans';
    font-size: 13px;
    color: #677888 !important;
  }
  .user-adding .name {
    font-family: 'DM Sans';
    font-size: 20px;
    color: #111 !important;
  }
  .add-user-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #E8F0F6;
  }
  .user-adding .add-user-btn {
    cursor: pointer;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #3F96D1;
    border-radius: 8px;
    color: #3F96D1;
    background-color: #fff;
    margin-bottom: 20px;
    font-family: 'DM Sans';
    font-size: 15px;
    width: 100%;
  }
  .user-adding .skip-btn {
    cursor: pointer;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #3F96D1;
    border-radius: 8px;
    font-family: 'DM Sans';
    color: #fff;
  }
  .adding-user {
    height: 100% !important;
  }
  .adding-user .user-adding .setup-name {
    height: 100% !important;
  }
  .user-adding .setup-name {
    padding: 0 !important;
    margin: 0 auto !important;
  }
  .user-adding .add-user {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .dept-lists-height {
    height: 200px;
    overflow-y: auto;
  }
  .dept-lists {
    margin-top: 2em;
    margin-bottom: 0 !important;
  }
  .dept-box {
    border: 1px solid #A7B9CB;
    border-radius: 8px;
    height: 56px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    color: #111111;
    font-family: 'DM Sans';
    margin-right: 10px;
  }
  .department-setup .submit span {
    cursor: pointer;
    background-color: #3F96D1;
    height: 56px;
    border-radius: 8px;
    color: #fff !important;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: normal;
    font-family: 'DM Sans';
  }
  .add-btn {
    cursor: pointer;
    height: 56px;
    width: 140px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #3F96D1;
    margin-left: 10px;
    color: #fff !important;
  }
  .setup .submit button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
  .setup {
    background-color: transparent !important;
    border: none !important;
  }
  .setup h3 {
    font-family: 'Larsseit' !important;
    font-size: 28px;
    margin-bottom: 5px;
    font-weight: 700;
    color: #111111 !important;
  }
  .setup p {
    font-family: 'DM Sans';
    color: #4B5458 !important;
    font-size: 16px;
    line-height: 22.4px;
  }
  .setup form {
    text-align: left;
  }
  .setup form label {
    font-family: 'DM Sans';
    color: #677888 !important;
    font-size: 16px !important;
  }
  .setup form input {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }

  .setup-name .submit button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }
  .setup .submit button {
    background-color: #3F96D1 !important;
    height: 56px !important;
    color: #fff !important;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
  }
  .setup-name {
    border: none !important;
  }
  .setup-name h3 {
    font-family: 'Larsseit' !important;
    font-size: 28px;
    margin-bottom: 5px !important;
    font-weight: 700;
    color: #111111 !important;
  }
  .setup-name p {
    font-family: 'DM Sans';
    color: #4B5458 !important;
    font-size: 16px;
    line-height: 22.4px;
  }
  .setup-name form {
    text-align: left;
  }
  .setup-name form label {
    font-family: 'DM Sans';
    color: #677888 !important;
    font-size: 16px !important;
  }
  .setup-name form input {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }
  .setup-name form select {
    border: 1px solid #A7B9CB !important;
    background-color: #fff !important;
    font-size: 15px !important;
    padding: 1em .9em !important;
    text-align: left !important;
    font-family: 'DM Sans' !important;
    border-radius: 8px !important;
  }
  .security-question {
    background-color: #fff;
  }
    input[type="checkbox"] {
      border: 1px solid #ccc;
      width: auto !important;
      display: inline !important;
    }
    .security-question .setup {
      padding: 1.8em !important;
    }
    .security-question .setup .form {
      width: auto;
    }
    .add-employee {
      flex-direction: column;
    }
    .user-adding {
      flex-direction: row !important;
    }
    .input div {
      flex-flow: 1 !important;
      margin-left: 10px;
    }
    .input div:first-child {
      margin-left: 0 !important;
    }

    .not div {
      margin-left: 0 !important;
    }

    .not div input {
      margin-right: 10px !important;
    }

    .security-question .setup .form div:last-child {
      height: 100px;
    }
</style>
<script>
import loading from '@/components/Loading'
import sendquestion from '@/components/Forgot-Security-Question'
import AuthenticationService from '../services/AuthenticationService'
import cookies from '@/services/cookies'
import logout from '@/components/Logout'

export default {
  components: {
    loading,
    sendquestion,
    logout
  },
  data () {
    return {
      answer: '',
      error: {
        answer: false,
        message: false
      },
      name: '',
      post: true
    }
  },
  methods: {
    hideError () {
      this.error.answer = false
    },
    forgot_question () {
      this.$refs.sendquestion.load()
    },
    close () {
      this.error.message = false
    },
    authuser (evt) {
      if (evt.keyCode === 13) {
        this.post = true

        if (this.answer === '') {
          this.post = false
          this.error.answer = true
        } else {
          this.error.answer = false
        }

        if (this.post) {
          this.$refs.loading.load()
          let that = this
          let data = {
            answer: this.answer,
            token: cookies.getCookie('temp_token'),
            keepme: sessionStorage.getItem('keepme')
          }

          AuthenticationService.verifyanswer(data)
            .then(res => {
              if (res.data.data === true) {
                localStorage.setItem('id', res.data.id)
                // that.$refs.loading.close()
                sessionStorage.setItem('status', true)
                sessionStorage.setItem("dir_id", res.data.directory_id);

                if (sessionStorage.getItem('redirect') !== undefined && sessionStorage.getItem('redirect') !== '' && sessionStorage.getItem('redirect') !== null) {
                  let location = sessionStorage.getItem('redirect')
                  sessionStorage.removeItem('redirect')
                  window.location = location
                } else {
                  localStorage.setItem('id', res.data.id)
                  // that.$refs.loading.close()
                  sessionStorage.setItem('status', true)
                  if (process.env.VUE_APP_NODE_ENV === 'development') {
                    that.$router.push('/')
                  } else {
                    window.location = process.env.VUE_APP_DASHBOARD
                  }
                }
              } else {
                if (res.data.reason === 'expired') {
                  that.$router.push('login')
                }

                if (res.data.reason === 'wrong') {
                  that.$refs.loading.close()
                  that.error.message = true
                }
              }

              if (res.data.data === 'logout') {
                that.$router.push('login')
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
      return false
    },
    submit () {
      this.post = true

      if (this.answer === '') {
        this.post = false
        this.error.answer = true
      } else {
        this.error.answer = false
      }

      if (this.post) {
        this.$refs.loading.load()
        let that = this
        let data = {
          answer: this.answer,
          token: cookies.getCookie('temp_token'),
          keepme: sessionStorage.getItem('keepme')
        }

        AuthenticationService.verifyanswer(data)
          .then(res => {
            if (res.data.data === true) {
              localStorage.setItem('id', res.data.id)
              sessionStorage.setItem('status', true)
              sessionStorage.setItem("dir_id", res.data.directory_id);
              // that.$refs.loading.close()
              if (sessionStorage.getItem('redirect') !== undefined && sessionStorage.getItem('redirect') !== '' && sessionStorage.getItem('redirect') !== null) {
                let location = sessionStorage.getItem('redirect')
                sessionStorage.removeItem('redirect')
                window.location = location
              } else {
                localStorage.setItem('id', res.data.id)
                // that.$refs.loading.close()
                sessionStorage.setItem('status', true)
                if (process.env.VUE_APP_NODE_ENV === 'development') {
                  that.$router.push('/')
                } else {
                  window.location = process.env.VUE_APP_DASHBOARD
                }
              }
            } else {
              if (res.data.reason === 'expired') {
                that.$router.push('login')
              }

              if (res.data.reason === 'wrong') {
                that.$refs.loading.close()
                that.error.message = true
              }
            }

            if (res.data.data === 'logout') {
              that.$router.push('login')
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    logout () {
      this.$refs.logout.logout()
    }
  },
  mounted () {
    let that = this
    if (cookies.getCookie('temp_token') !== '' && cookies.getCookie('temp_token') !== null) {
      let data = {
        token: cookies.getCookie('temp_token')
      }

      this.$socket.emit('auth', data, data => {
        if (data.data === false) {
          that.$router.push('/login')
        } else {
          that.name = data.name
        }
        // } else {
        //   console.log(sessionStorage.getItem('status'))
        //   if (sessionStorage.getItem('status') !== 'true') {
        //     that.name = data.name
        //   } else {
        //     console.log('It went to drive dashboard')
        //     that.$router.push('/')
        //   }
        // }
      })
    } else {
      this.$router.push('/login')
    }
  }
}
</script>
